module.exports = __webpack_public_path__ + "static/media/dumbbell-solid.7dbe96cc.svg";